import AnimationClip from '../AnimationClip';
import { Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import UITextComponent from "../../../Component/UI/Text";

export interface ICounterMeta {
    startValue: number;
    finalValue: number;
    duration: number;
}

export class Counter extends AnimationClip {
    private value: number;
    private textComponent: UITextComponent;
    public *execute(
        gameObject: GameObject,
        meta?: ICounterMeta
    ): IterableIterator<number> {
        this.textComponent = gameObject.getComponent(UITextComponent);

        this.value = meta.startValue;
        this.textComponent.text = this.value.toFixed(0);

        const tween: Tween = this.getTween(this);
        tween.to({ value: meta.finalValue }, meta.duration);

        yield* this.startTween(tween);
    }

    public update(): void {
        super.update();
        this.textComponent.text = this.value.toFixed(0);
    }
}
